module.exports = __webpack_public_path__ + "img/ps-40.933440a9.jpg";